import {API_URL} from "../../../constants";
import {makeRequest} from "../../../services/requestService";
import {useTranslation} from "react-i18next";
import React from "react";
import {
    Box,
    Button,
    FormControlLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    Switch,
    TextField
} from "@mui/material";
import * as PropTypes from "prop-types";

async function updateCollection(collection) {
    const url = `${API_URL}/collection/${collection.id}`;

    const body = {
        name: collection.name,
        description: collection.description,
        visibility: collection.visibility,
    }

    const response = await makeRequest(url, "PUT", body, {
        'Content-Type': 'application/json'
    });
    return response.data;
}

export default function GeneralTab(props) {
    const {t} = useTranslation("common")
    const [disabled, setDisabled] = React.useState(true);
    const [collection, setCollection] = React.useState({...props.collection});

    async function handleSave() {
        const updatedCollection = await updateCollection(collection);
        if (props.onCollectionUpdate) {
            props.onCollectionUpdate(updatedCollection);
        }
    }

    function handleReset() {
        setCollection({...props.collection});
    }

    return (<Stack>
        <Box display="flex" justifyContent="flex-end" mb={2}>
            <FormControlLabel
                control={
                    <Switch value={!disabled}
                            onChange={(_, checked) => setDisabled(!checked)}/>
                } label={t('main.pages.admin.collection.tabs.general.edit')}
            />
        </Box>
        <form>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t('main.components.form.collection.placeholder.name')}
                        value={collection.name}
                        onChange={(event) => setCollection({...collection, name: event.target.value})}
                        disabled={disabled}/>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t('main.components.form.collection.placeholder.description')}
                        value={collection.description}
                        onChange={(event) => setCollection({...collection, description: event.target.value})}
                        disabled={disabled}/>
                </Grid>
                <Grid item xs={6}>
                    <InputLabel
                        id="select-visibility-label">{t('main.components.form.collection.placeholder.visibility')}</InputLabel>
                    <Select
                        color="secondary"
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="select-visibility-label"
                        name="visibility"
                        onChange={(event) => setCollection({...collection, visibility: event.target.value})}
                        value={collection.visibility}
                        disabled={disabled}
                    >
                        <MenuItem value="PRIVATE">{t('main.components.form.collection.visibility.private')}</MenuItem>
                        <MenuItem value="PUBLIC">{t('main.components.form.collection.visibility.public')}</MenuItem>
                    </Select>

                </Grid>
                <Grid item xs={6}>
                </Grid>
                <Grid item xs={12}>
                    <Box display="flex" justifyContent="flex-end" gap={1}>
                        <Button type="reset" variant="outlined" onClick={() => handleReset()} disabled={disabled}>
                            {t("main.components.button.reset")}
                        </Button>
                        <Button type="submit" variant="contained" onClick={() => handleSave()} disabled={disabled}>
                            {t("main.components.button.save")}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </form>
    </Stack>);
}

GeneralTab.propTypes = {
    collection: PropTypes.object.isRequired,
    onCollectionUpdate: PropTypes.func,
}